import React from "react";
import { ReactComponent as VerifiedCheck } from "../../../assets/images/Verified_Check.svg";
import { ReactComponent as WarningTriangle } from "../../../assets/icons/WarningTriangle.svg";
import profile from "../../../assets/images/profile.svg";

export const VerifiedByTrevex = ({ status, logo=false }) => {
  const statusConfig = {
    verified: {
      bgClass: "bg-gradient-to-r from-verifies to-verified",
      icon: <VerifiedCheck />,
      text: "An authorized representative manages this company profile, and it has been verified by TREVEX.",
    },
    claimed: {
      bgClass: "bg-claimed",
      icon: <VerifiedCheck />,
      text: "An authorized representative has accessed and actively manages this company profile.",
    },
    warning: {
      bgClass: "bg-highWarning",
      icon: <WarningTriangle />,
      text: "Information on this profile is compiled from secondary data sources.",
    },
    listing: {
      bgClass: "",
      inlineStyle: { backgroundColor: "darkgrey" },
      icon: <WarningTriangle />,
      text: "This profile is a directory-based listing featuring globally-sourced information.",
    },
  };

  const config = statusConfig[status];

  if (!config) return null; // Return nothing if status is not recognized

  return (
      <div
        className={`${config.bgClass} text-slate font-semibold py-2 px-0 relative flex items-center justify-end sm:justify-center`}
        style={config.inlineStyle}
      >
        <div className="w-[calc(100%-120px)] sm:w-full flex items-center justify-center gap-1">
        <div className="hidden sm:block max-w-[21px]">{config.icon}</div>
        <p className="uppercase text-slate font-semibold text-[9px] sm:text-f14 text-left">
          {config.text}
        </p>
        </div>
        {<img class="block sm:hidden absolute top-[-24px] left-[14px] rounded-[4px] border-[4px] border-[#DBDBDB] sm:h-auto h-[90px] sm:w-auto w-[90px]" src={logo ? logo : profile} alt="Company Logo" />}
      </div>
  );
};

